import { useCallback, useEffect, useState } from "react";
import { FileUp } from "lucide-react";
import { toast } from "sonner";
import { api, API, formatApiError } from "@/lib/api";

const PLAN_TITLES = { 1: "Link 1", 2: "Link 2", 3: "Link 3" };

const Slot = ({ s, onDone }) => {
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try { await api.put(`/admin/contract-templates/${s.slot}`, fd); toast.success("PDF salvato"); onDone(); } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <div data-testid={`template-slot-${s.slot}`} className="flex flex-col gap-3 border-t border-[#1c1418]/15 py-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="font-display text-2xl uppercase leading-none">{s.label}</p>
        <p className="mt-1 text-sm">
          {s.filename ? <a href={`${API}/admin/contract-templates/${s.slot}/pdf`} target="_blank" rel="noopener noreferrer" className="underline">{s.filename}</a> : <span className="text-[#1c1418]/70">Nessun PDF caricato</span>}
        </p>
      </div>
      <label className="flex w-fit cursor-pointer items-center gap-2 border border-[#1c1418] px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em]">
        <FileUp className="h-4 w-4 text-[#e9458f]" /> {busy ? "Caricamento…" : s.filename ? "Sostituisci PDF" : "Carica PDF"}
        <input type="file" accept="application/pdf" onChange={upload} className="hidden" data-testid={`template-input-${s.slot}`} />
      </label>
    </div>
  );
};

export const TemplatesPanel = () => {
  const [slots, setSlots] = useState([]);
  const load = useCallback(() => { api.get("/admin/contract-templates").then((r) => setSlots(Array.isArray(r.data) ? r.data : [])).catch(() => toast.error("Errore nel caricamento")); }, []);
  useEffect(() => { load(); }, [load]);
  const plans = [...new Set(slots.map((s) => s.plan))];
  return (
    <div data-testid="templates-panel" className="max-w-3xl space-y-10">
      <p className="text-sm">Il PDF associato a ogni link. Quando invii un link a una modella approvata, lei trova nella sua area questi contratti da firmare. Se sostituisci un PDF, vale per i nuovi invii.</p>
      {plans.map((p) => (
        <div key={p}>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">{PLAN_TITLES[p]} · {slots.filter((s) => s.plan === p).length > 1 ? "due contratti" : "un contratto"}</p>
          {slots.filter((s) => s.plan === p).map((s) => <Slot key={s.slot} s={s} onDone={load} />)}
        </div>
      ))}
    </div>
  );
};
